import React, { useCallback } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { Button } from '@hey-car/ui';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { trackAction } from 'app/shared/utils/tracking';
import { createStructuredSelector } from 'reselect';
import { selectUserLoggedIn } from 'app/dealer/login/selectors';
import { selectNetwork } from 'app/dealer/account/Network/selectors';
import {
  ErrorPageSt,
  ErrorImageSt,
  TitleSt,
  ErrorPageContainerSt,
} from './ErrorPage.css';
import DealerPage from 'app/dealer/shared/layouts/DealerPage';
import { PUBLIC_BASE } from 'app/config';

const messages = defineMessages({
  pageTitle: {
    id: 'app.shared.components.ErrorPage',
    defaultMessage: 'heycar',
  },
  metaDescription: {
    id: 'dealer.dashboard.Dashboard.metaDescription',
    defaultMessage:
      'Die Gebrauchtwagenplattform mit den besten Autos von Top-Händlern. 1A Gebrauchwagen, Top-Händler, Keine Werbung',
  },
});

const ErrorPageCmp = ({ errorCode, target, intl, network, userLoggedIn }) => {
  const handleOnClick = useCallback(() => {
    trackAction(`${errorCode}_home_click`, {
      category: `${target}`,
      description: 'user clicks on home link from error page',
    });
    const homeSubpath = userLoggedIn ? 'dashboard' : 'login';
    browserHistory.push(`/dealer/${homeSubpath}`);
  }, [errorCode, target, userLoggedIn]);

  return (
    <DealerPage
      intl={intl}
      messages={messages}
      network={network}
      showMenu={userLoggedIn}
      topNavBarTarget="page-not-found"
      footerTarget="page-not-found"
    >
      <ErrorPageContainerSt>
        <ErrorPageSt>
          <ErrorImageSt
            src={`${PUBLIC_BASE}/assets/errors/pity_error.svg`}
            alt="hey car error page"
            title="hey car error page"
          />
          <FormattedMessage
            id="shared.components.ErrorPage.notFound"
            tagName="h2"
            defaultMessage="Ups, eine kleine Panne ist aufgetreten."
          >
            {(text) => <TitleSt>{text}</TitleSt>}
          </FormattedMessage>

          <FormattedMessage
            id="shared.components.ErrorPage.goToDealerHome.Link"
            defaultMessage="Zurück zur Startseite"
          >
            {(text) => <Button onClick={handleOnClick}>{text}</Button>}
          </FormattedMessage>
        </ErrorPageSt>
      </ErrorPageContainerSt>
    </DealerPage>
  );
};

ErrorPageCmp.propTypes = {
  errorCode: PropTypes.number,
  target: PropTypes.string,
  intl: intlShape.isRequired,
  userLoggedIn: PropTypes.bool,
};

ErrorPageCmp.defaultProps = {
  target: 'error_page',
  errorCode: 404,
  userLoggedIn: false,
};

const mapStateToProps = createStructuredSelector({
  network: selectNetwork,
  userLoggedIn: selectUserLoggedIn,
});

export const ErrorPage = compose(
  connect(mapStateToProps),
  injectIntl
)(ErrorPageCmp);
